import React, { createContext, useCallback, useEffect, useState } from 'react'
import { EN } from 'config/localization/languages'
import translations from 'config/localization/translations.json'
import { ContextApi, ContextData, ProviderState, Language } from './types'

const initialState: ProviderState = {
  isFetching: true,
  currentLanguage: EN,
}

// Export the translations directly
export const languageMap = new Map<Language['locale'], Record<string, string>>()
languageMap.set(EN.locale, translations)

export const LanguageContext = createContext<ContextApi>(undefined)

export const LanguageProvider: React.FC = ({ children }) => {
  // English only: always use EN, ignore localStorage and language switcher
  const [state, setState] = useState<ProviderState>({
    ...initialState,
    currentLanguage: EN,
  })

  useEffect(() => {
    setState((prevState) => ({ ...prevState, isFetching: false }))
  }, [])

  const setLanguage = useCallback(async () => {
    // English only: no-op, language never changes
  }, [])

  const translate = useCallback((key: string, data?: ContextData) => {
    const translationSet = languageMap.get(EN.locale)
    const translatedText = translationSet[key] || key

    // Check the existence of at least one combination of %%, separated by 1 or more non space characters
    const includesVariable = translatedText.match(/%\S+?%/gm)

    if (includesVariable && data) {
      let interpolatedText = translatedText
      Object.keys(data).forEach((dataKey) => {
        const templateKey = new RegExp(`%${dataKey}%`, 'g')
        interpolatedText = interpolatedText.replace(templateKey, data[dataKey].toString())
      })

      return interpolatedText
    }

    return translatedText
  }, [])

  return <LanguageContext.Provider value={{ ...state, setLanguage, t: translate }}>{children}</LanguageContext.Provider>
}
